function isLive(track) {
  return Boolean(track) && track.readyState === "live";
}

function isOnDevice(track, deviceId) {
  return !deviceId || track.getSettings?.().deviceId === deviceId;
}

function planPreviewTracks({ wantsVideo, wantsAudio, videoTrack, audioTrack, videoDeviceId, audioDeviceId = null }) {
  const keepVideo = wantsVideo && isLive(videoTrack) && isOnDevice(videoTrack, videoDeviceId);
  const keepAudio = wantsAudio && isLive(audioTrack) && isOnDevice(audioTrack, audioDeviceId);

  return {
    keep: [keepVideo ? videoTrack : null, keepAudio ? audioTrack : null].filter(Boolean),
    stop: [!keepVideo ? videoTrack : null, !keepAudio ? audioTrack : null].filter(Boolean),
    requestVideo: wantsVideo && !keepVideo,
    requestAudio: wantsAudio && !keepAudio,
  };
}

module.exports = {
  planPreviewTracks,
};
